<script>
import DetailBanner from '../components/detailBanner.vue';
import List from '../components/list.vue';
import MineButton from '../components/mineButton.vue';
import SizeSelect from '../components/sizeSelect.vue';
export default {
    name: "Detail",
    data() {
        return {
            detail: {
                color: [],
            },
            colorActiveIndex: 0,
            scrollActiveIndex: 0,
            size: '',
            moreList: [],
            isLoading: false,
            isShowSizeChart: false,
            isAddLoading: false,
            showError: false,
            errorText: ''
        };
    },
    computed: {
        toNumber(){
            return str => {
                return parseFloat(str).toFixed(2).toLocaleString();
            }
        },
        textToHtml(){
            return text => {
                return text.replace(/\r\n/ig, '<br/>');
            }
        },
    },
    components: {
        SizeSelect,
        List,
        DetailBanner,
        MineButton
    },
    mounted() {
        this.$store.state.isJump = true;
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        '$route.query.id': {
            handler: function(id){
                this.getData();
            },
            immediate: true
        },
        '$route.query.color': 'chooseColor',
    },
    methods: {
        chooseColor(name){
            for (let i = 0; i < this.detail.color.length; i++) {
                const item = this.detail.color[i];
                if(item.name == name){
                    this.colorActiveIndex = i;
                    break;
                }
            }
        },
        getData(){
            this.isLoading = true;
            this.$store.dispatch('getDetail', {
                id: this.$route.query.id,
            }).then((result) => {
                this.isLoading = false;
                this.detail = result.info;
                this.moreList = result.recommend;
                if(this.$route.query.color){
                    this.chooseColor(this.$route.query.color);
                }
            });
        },
  	    //滚动事件
        handleScroll() {
            if(this.$refs.images){
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                // console.log(this.$refs.images.offsetTop);
                let index = 0;
                for (let i = 0; i < this.$refs.images.length; i++) {
                    const item = this.$refs.images[i];
                    if(item.offsetTop - (windowHeight / 2) - scrollTop <= 0){
                        index = i;
                    }else{
                        break;
                    }
                }
                this.scrollActiveIndex = index;
            }
        },
        to(index){
            window.scrollTo({
                behavior: "smooth",
                top: this.$refs.images[index].offsetTop - this.$refs.imagesWrap.offsetTop
            })
        },
        addShopping(){
            if(!this.size){
                this.$refs.sizeSelect.showOption();
                return;
            }
            this.isAddLoading = true;
            this.$store.dispatch('addShopping', {
                goods_id: this.detail.id,
                color_id: this.detail.color[this.colorActiveIndex].id,
                size_id: this.size,
            }).then((result) => {
                this.isAddLoading = false;
                this.$showToast({ text: 'Add successfully' }); //添加成功
            }).catch((err) => {
                this.isAddLoading = false;
                if(err && err.code == 102){
                    switch (this.$route.query.id) {
                        case '8':
                        this.errorText = 'Back in store in April';
                        break;
                        case '47':
                        this.errorText = 'Back in store at the end of March';
                        break;
                        case '65':
                        this.errorText = 'Back in store at the end of March';
                        break;
                    
                        default:
                        this.errorText = 'Insufficient stock';
                        break;
                    }
                    // this.$showToast({ text: 'Insufficient stock' }); //库存不足
                }else{
                    this.errorText = 'Add failure';
                    // this.$showToast({ text: 'Add failure' }); //添加失败
                }
                this.showError = true;
                setTimeout(()=>{
                    this.showError = false;
                }, 2000)
            });
        },
        showSizeChart(){
            this.isShowSizeChart = true;
            document.body.style.overflow = 'hidden';
        },
        closeSizeChart(){
            this.isShowSizeChart = false;
            document.body.style.overflow = 'auto';
        },
    },
};
</script>

<template>
    <div class="container detail">
        <template v-if="!isLoading">
            <div class="content">
                <!-- left menu -->
                <div class="images_menu" v-if="detail.color">
                    <div class="item" v-for="(item, index) in detail.color[colorActiveIndex].banner" :key="index" :class="{active: scrollActiveIndex == index}" @click="to(index)">
                        <img :src="item" alt=""/>
                    </div>
                </div>
                <!-- main -->
                <div class="images" ref="imagesWrap" v-if="detail.color">
                    <div class="item" ref="images" v-for="(item, index) in detail.color[colorActiveIndex].banner" :key="index">
                        <img :src="item" alt=""/>
                    </div>
                </div>
                <div class="banner_wrap">
                    <DetailBanner :data="detail.color[colorActiveIndex].banner"/>
                </div>
                <!-- right info -->
                <div class="info">
                    <div class="group">
                        <div class="name">{{detail.name}}</div>
                        <div class="price" v-if="detail.price != '999.00'">€ {{toNumber(detail.price)}}</div>
                    </div>
                    <div class="group color_wrap" v-if="detail.color">
                        <div class="title">Color</div>
                        <div class="colors">
                            <router-link class="color" 
                            v-for="(item, index) in detail.color" :key="index" 
                            :style="{backgroundColor: item.color_code}" 
                            :class="{white: item.color_code == '#ffffff'}"
                            :to="`/detail?id=${detail.id}&color=${item.name}`"></router-link>
                        </div>
                    </div>
                    <div class="group size">
                        <div class="title">Size Guide</div>
                        <SizeSelect ref="sizeSelect" :data="detail.size" v-model="size"/>
                        <!-- <div class="btn" @click.stop="addShopping">Add to Shopping Bag</div> -->
                        <MineButton :loading="isAddLoading" @click="addShopping" :disabled="detail.price == '999.00'">Add to Shopping Bag</MineButton>
                        <!-- 报错提示 -->
                        <div class="error_wrap">
                            <div class="error" :class="{show: showError}">{{errorText}}</div>
                        </div>
                    </div>
                    <p class="group desc" v-if="detail.desc" v-html="textToHtml(detail.desc)"></p>
                    <p class="group size_chart" v-if="detail.size_chart.length > 0 || detail.size_chart_text.length > 0"><span @click="showSizeChart">Size chart</span></p>
                </div>
            </div>
            <div class="more" v-if="moreList.length > 0">
                <p class="title">Maybe You Like</p>
                <List :data="moreList"/>
            </div>
        </template>
        <div class="popup" :class="{active: isShowSizeChart}">
            <div class="close" @click="closeSizeChart"></div>
            <div class="in">
                <div class="btn_close" @click="closeSizeChart"></div>
                <div class="top">
                    <p class="title">Size chart</p>
                    <!-- <p class="desc">All measurements are in cm / inches</p> -->
                    <p class="desc">All measurements are in cm</p>
                </div>
                <div class="popup_content">
                    <div class="table" v-if="detail.size_chart && detail.size_chart.length > 0">
                        <div class="tr" v-for="(item, index) in detail.size_chart" :key="index">
                            <div class="td" v-for="(_item, _index) in item" :key="_index">{{_item}}</div>
                        </div>
                    </div>
                    <div class="text_group" v-if="detail.size_chart_text && detail.size_chart_text.length > 0">
                        <div class="item" v-for="(item, index) in detail.size_chart_text" :key="index">
                            <p class="title">{{item.title}}</p>
                            <p class="desc">{{item.content}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.popup{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: .5);
    opacity: 0;
    visibility: hidden;
    transition: all .3s;
    z-index: 1;
    &.active{
        opacity: 1;
        visibility: visible;
        .in{
            transform: translate(0, 0);
        }
    }
    .close{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .in{
        width: 650px;
        height: 100%;
        background: #fff;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(100%, 0);
        transition: all .3s;
        padding: 110px 0 0;
        display: flex;
        flex-direction: column;
        .btn_close{
            position: absolute;
            top: 165px;
            right: 40px;
            width: 16px;
            height: 16px;
            overflow: hidden;
            cursor: pointer;
            &::before,
            &::after{
                content: "";
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
                width: 30px;
                border-bottom: 2px solid #000;
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
        .top{
            padding: 55px 0 25px;
            border-bottom: 1px solid #e0e0e0;
            flex-shrink: 0;
            margin: 0 40px;
            .title{
                font-size: 20px;
                color: #333;
                margin-bottom: 20px;
            }
            .desc{
                color: #999;
            }
        }
        .popup_content{
            flex: 1;
            overflow: hidden;
            overflow-y: auto;
            padding: 20px 40px;
            .table{
                color: #666666;
                margin-bottom: 70px;
                .tr{
                    display: flex;
                    height: 45px;
                    &:nth-of-type(2n){
                        background: #f5f5f5;
                    }
                    .td{
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        &:first-child{
                            flex: 2;
                            justify-content: flex-start;
                            padding-left: 10px;
                        }
                    }
                }
            }
            .text_group{
                line-height: 2;
                .item{
                    margin-bottom: 20px;
                    .title{
                        color: #333;
                        font-weight: bold;
                    }
                    .desc{
                        color: #999;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 768px) {
        .in{
            width: 100%;
            padding: 1.2rem 0 0;
            transform: translate(0, 100%);
            .btn_close{
                width: .24rem;
                height: .24rem;
                top: 1.5rem;
                right: .25rem;
            }
            .top{
                margin: 0 .25rem;
                padding: .3rem 0 .22rem;
                .title{
                    font-size: .3rem;
                    margin-bottom: .3rem;
                }
                .desc{
                    font-size: .22rem;
                }
            }
            .popup_content{
                padding: .4rem 0;
                .table{
                    margin-bottom: 1rem;
                    .tr{
                        height: .72rem;
                        .td{
                            &:first-child{
                                padding-left: .3rem;
                            }
                        }
                    }
                }
                .text_group{
                    padding: 0 .3rem;
                    .item{
                        margin-bottom: .2rem;
                    }
                }
            }
        }
    }
}
.detail{
    .content{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin-bottom: 100px;
    }
    .images_menu{
        position: sticky;
        width: 100px;
        margin-right: 40px;
        top: 110px;
        // left: 0;
        .item{
            margin-bottom: 20px;
            cursor: pointer;
            border: 1px solid transparent;
            transition: border-color .3s;
            &:last-child{
                margin-bottom: 0;
            }
            img{
                width: 100%;
            }
            &.active{
                border-color: #000;
            }
        }
    }
    .images{
        width: 600px;
        .item{
            // margin-bottom: 30px;
            &:last-child{
                margin-bottom: 0;
            }
            img{
                width: 100%;
            }
        }
    }
    .info{
        width: 260px;
        margin-left: 40px;
        padding-top: 20px;
        line-height: 1.8;
        position: sticky;
        top: 110px;
        .group{
            margin-bottom: 30px;
            font-size: 12px;
            .title{
                margin-bottom: 5px;
                font-weight: bold;
            }
        }
        .name,
        .price{
            font-weight: bold;
        }
        .color_wrap{
            .colors{
                display: flex;
                margin-bottom: 20px;
                .color{
                    width: 8px;
                    height: 8px;
                    margin-right: 8px;
                    position: relative;
                    cursor: pointer;
                    &.white{
                        border: 1px solid #dfdfdf;
                    }
                    &.exact-active{
                        &::after{
                            content: "";
                            display: block;
                            width: 10px;
                            height: 10px;
                            border: 1px solid #777;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
        }
        .size{
            .btn{
                height: 40px;
                margin-top: 10px;
                background: #000;
                color: #fff;
                font-size: 12px;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                user-select: none;
                position: relative;
                z-index: 1;
                &.gray{
                    background: #838383;
                    pointer-events: none;
                }
            }
            .error_wrap{
                position: relative;
                .error{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    background: gray;
                    color: #fff;
                    text-align: center;
                    height: 30px;
                    line-height: 30px;
                    transform: translate(0, -100%);
                    transition: transform .3s;
                    &.show{
                        transform: translate(0, 0);
                    }
                }
            }
        }
        .size_chart{
            span{
                border-bottom: 1px solid #000;
                cursor: pointer;
            }
        }
    }
    .more{
        padding: 0 55px 0;
        .title{
            margin: 0 25px 25px;
            padding: 25px 0;
            border-bottom: 1px solid #000;
            font-size: 12px;
            font-weight: bold;
        }
    }
    .banner_wrap{
        display: none;
    }
    @media screen and (max-width: 768px) {
        .banner_wrap{
            display: block;
        }
        .content{
            display: block;
            margin-bottom: 0;
            .images,
            .images_menu{
                display: none;
            }
            .info{
                position: relative;
                top: 0;
                padding: 0;
                margin: 0;
                width: 100%;
                padding: .25rem .25rem 0;
                line-height: 2;
                .group{
                    margin-bottom: .6rem;
                    font-size: .24rem;
                    .title{
                        margin-bottom: .1rem;
                    }
                }
                .color_wrap{
                    .colors{
                        .color{
                            width: .24rem;
                            height: .24rem;
                            margin-right: .24rem;
                            &::after{
                                width: .36rem;
                                height: .36rem;
                            }
                        }
                    }
                }
                .size{
                    .btn{
                        height: .7rem;
                        font-size: .24rem;
                        line-height: .7rem;
                    }
                    .error_wrap{
                        .error{
                            height: .5rem;
                            line-height: .5rem;
                        }
                    }
                }
            }
        }
        .more{
            padding: 0 .25rem;
            .title{
                margin: 0 0 .35rem;
                padding: .25rem 0;
                font-size: .24rem;
                border-bottom-color: #a5a5a5;
            }
        }
    }
}
</style>